import{configureStore} from '@reduxjs/toolkit';
import bb from './slices/cartSlice';
import mm from './slices/favoriteSlice';


const store=configureStore({
  reducer:{
    cart:bb,
    favorite:mm
  }
})

export default store;